import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dietFilter'
})
export class DietFilterPipe implements PipeTransform {

  transform(items: any, element:string, value:any) {
    if(items != null && items != undefined && items.length > 0 && value != undefined && value.length > 0)
    {
      if(items != undefined )
      {
        if (value.length > 0) 
        {
          return this.filterDiet(items, value, element);
        }
        else
        {
          return items;
        }
      }
    }
    else
    {
      return items;
    }
    return items;
  }

  filterDiet(mainItems, value, element)
  {
    let finalItems = [];
    mainItems.filter((mainItem:any) => {
      mainItem.item.forEach(item => {
        if(item[element] != null && value != null && value.length > 0)
        {
          item[element].split(',').forEach(dietId => {
            if(value.filter(x => dietId.indexOf(x) != -1).length > 0)
            {
              finalItems.push(mainItem);
            }         
          });
        }
      });
     
    });
    return finalItems.filter(function(item, index) { return finalItems.indexOf(item) >= index;});
  }

}
